import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';
import { RegisteredDisclaimer } from '../helpers/get-disclaimer';
import {
	CarlineWithOfertas,
	Oferta,
	Promocion,
} from '../services/ofertas-service/models/ofertas';
import { OfertaCard } from './oferta-card/oferta-card';

const OfertasContainer = styled.div<{
	isMobile: boolean;
	hasOneCarline: boolean;
}>`
	position:  ${(props) => props.isMobile && !props.hasOneCarline && 'absolute'};
	top: ${(props) => props.isMobile && !props.hasOneCarline && '190px'};
	left: ${(props) => props.isMobile && '0'};
	
	display: flex;
	flex-direction: ${(props) => (props.isMobile ? 'row' : 'column')}};
	gap: ${(props) => props.theme.size.static200};
	
	overflow-x: ${(props) => props.isMobile && 'scroll'};
	padding: ${(props) => props.isMobile && props.theme.size.static250};
	max-width: 100%;
	height:  ${(props) => props.isMobile && props.hasOneCarline && 'fit-content'};

	@media screen and (max-width: 1279px) { 
		position:  ${(props) => props.isMobile && props.hasOneCarline && 'relative'};
		top:  ${(props) => props.isMobile && props.hasOneCarline && '0'};
		padding-bottom:  ${(props) => !props.isMobile && props.hasOneCarline && 'var(--size-dynamic0120)'};
	}

	::-webkit-scrollbar {
		display: none; /* for Chrome, Safari and Opera */
	  	scrollbar-width: none;  /* Firefox */
	}
`;

export const OfertasCardContainer = ({
	carline,
	hasOneCarline,
	isMobile,
	isLayerVisible,
	setIsLayerVisible,
	selectedOferta,
	setSelectedOferta,
	handleLayerOnClick,
	setSelectedPromotion,
	disclaimers,
}: {
	carline: CarlineWithOfertas;
	hasOneCarline: boolean;
	isMobile: boolean;
	isLayerVisible: boolean;
	setIsLayerVisible: React.Dispatch<React.SetStateAction<boolean>>;
	selectedOferta: Oferta;
	setSelectedOferta: React.Dispatch<React.SetStateAction<Oferta>>;
	className: string;
	handleLayerOnClick: () => void;
	setSelectedPromotion: React.Dispatch<
		React.SetStateAction<Promocion | undefined>
	>;
	disclaimers: RegisteredDisclaimer[];
}): React.ReactElement => {
	return (
		<OfertasContainer
			isMobile={isMobile}
			hasOneCarline={hasOneCarline}
			className="ofertas__container"
		>
			<OfertaCard
				className="oferta-card"
				carline={carline}
				hasOneCarline={hasOneCarline}
				isMobile={isMobile}
				currentOferta={carline.ofertas[0]}
				isLayerVisible={isLayerVisible}
				setIsLayerVisible={setIsLayerVisible}
				selectedOferta={selectedOferta}
				setSelectedOferta={setSelectedOferta}
				handleLayerOnClick={handleLayerOnClick}
				setSelectedPromotion={setSelectedPromotion}
				disclaimers={disclaimers}
			/>

			{carline.ofertas && carline.ofertas[1] && (
				<OfertaCard
					className="oferta-card-2"
					carline={carline}
					hasOneCarline={hasOneCarline}
					isMobile={isMobile}
					currentOferta={carline.ofertas[1]}
					isLayerVisible={isLayerVisible}
					setIsLayerVisible={setIsLayerVisible}
					selectedOferta={selectedOferta}
					setSelectedOferta={setSelectedOferta}
					handleLayerOnClick={handleLayerOnClick}
					setSelectedPromotion={setSelectedPromotion}
					disclaimers={disclaimers}
				/>
			)}
		</OfertasContainer>
	);
};
